import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const EASE = [0.16, 1, 0.3, 1];

export default function PaymentCancel() {
  const { t } = useTranslation();

  return (
    <main data-testid="payment-cancel-page">
      <Header />
      <div className="pt-44 pb-32 max-w-xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="rounded-3xl border border-white/10 bg-card p-12"
        >
          <XCircle className="w-12 h-12 text-white/40 mx-auto" strokeWidth={1.5} />
          <h1 className="mt-6 font-display font-semibold text-white text-2xl">{t("payment.cancelTitle")}</h1>
          <p className="mt-3 text-sm text-white/60 leading-relaxed">{t("payment.cancelText")}</p>
          <Link
            to="/#pricing"
            data-testid="payment-cancel-pricing-link"
            className="mt-8 inline-flex items-center rounded-full bg-mint px-6 py-3 text-sm font-semibold text-night transition-transform duration-200 hover:scale-105"
          >
            {t("payment.backPricing")}
          </Link>
        </motion.div>
      </div>
      <Footer />
    </main>
  );
}
